import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admin--fetch"
export default class extends Controller {
  static targets = ["status"]
  static values = { url: String }

  fetch(event) {
    event.preventDefault()

    const data = new FormData(this.element)

    const url = this.hasUrlValue ? this.urlValue : this.element.action

    fetch(url, {
      method: "POST",
      body: data
    }).then((resp) => resp.json()).then((json) => {
      if (json.length == 0) {
        this.statusTarget.innerHTML = "Aucune correspondance trouvée pour ces références."
      } else {
        this.statusTarget.innerHTML = ""
      }
      json.forEach(v => {
        this.dispatch('valueReceived', { detail: { url: v } })
      });
    });
  }
}
